import type { Dispatch, SetStateAction } from 'react';
import { cn } from '@/utils/ui-utils';
import type { Routes } from '../../utils/parseRouteName';

type Section = {
  title: string;
  value: Routes | null;
};
const sections: Section[] = [
  { title: 'Alla', value: null },
  { title: 'Bostadsmarknad', value: 'areas' },
  { title: 'BRF', value: 'housing-coops' },
  { title: 'Bostäder', value: 'sales' },
  { title: 'Bostadsprojekt', value: 'projects' },
  { title: 'Bostadsutvecklare', value: 'developers' },
  { title: 'Mäklarbyråer', value: 'agencies' },
  { title: 'Mäklare', value: 'agents' },
  { title: 'Prisindex', value: 'indices' },
];
export const BookmarkMenu = ({
  section,
  setSection,
}: {
  section: Routes | null;
  setSection: Dispatch<SetStateAction<Routes | null>>;
}) => {
  return (
    <div className='flex w-[139px] shrink-0 flex-col items-start gap-4 pr-4'>
      {sections.map((s) => (
        <button
          type='button'
          key={s.title}
          className={cn(
            'decoration-highlight rounded-md decoration-2 underline-offset-8',
            s.value === section ? 'font-semibold underline' : 'no-underline',
            `focus-visible:ring-ring ring-offset-background focus-visible:ring-2 focus-visible:ring-offset-2
            focus-visible:outline-hidden`,
          )}
          onClick={() => setSection(s.value)}
        >
          {s.title}
        </button>
      ))}
    </div>
  );
};
